import { render, staticRenderFns } from "./modalAgregarAdministrador.vue?vue&type=template&id=f3b7e970&scoped=true&"
import script from "./modalAgregarAdministrador.vue?vue&type=script&lang=js&"
export * from "./modalAgregarAdministrador.vue?vue&type=script&lang=js&"
import style0 from "./modalAgregarAdministrador.vue?vue&type=style&index=0&id=f3b7e970&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b7e970",
  null
  
)

export default component.exports